/*
  Opens the Shopify Inbox chat window from any link marked data-open-chat.

  One delegated listener on the document rather than one per link, so it keeps
  working after the theme editor re-renders the product section and swaps the
  links out from under it -- and a guard, so the editor loading this file again
  on that re-render does not stack a second listener.

  Inbox loads its script async at low priority, so on a fast tap <shopify-chat>
  can be in the page before it has been defined. The click waits for the
  definition, but only for so long: if Inbox never arrives -- blocked by an
  extension, or down -- the link falls through to its own href, the contact
  page, rather than being a tap that does nothing.
*/
(function () {
  'use strict';

  if (window.fasAskExpertBound) return;
  window.fasAskExpertBound = true;

  const DEFINE_TIMEOUT_MS = 3000;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-open-chat]');
    if (!link) return;

    const chat = document.querySelector('shopify-chat');
    // No chat element on the page at all: Inbox is off. Let the href handle it.
    if (!chat) return;

    event.preventDefault();

    const giveUp = new Promise((resolve) => setTimeout(() => resolve(false), DEFINE_TIMEOUT_MS));
    const ready = customElements.whenDefined('shopify-chat').then(() => true);

    Promise.race([ready, giveUp]).then((defined) => {
      if (defined && typeof chat.show === 'function') {
        chat.show();
      } else {
        window.location.href = link.href;
      }
    });
  });
})();
